<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 基本信息 </a-col>
      </a-row>
      <!-- a-form-model ==>   layout="" -->
      <a-form-model
        :model="formInline"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="门店名称">
              <a-input v-model="data.hotelName" placeholder="请输入门店名称">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="客服电话">
              <a-input v-model="data.phone" placeholder="请输入联系电话">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="负责人姓名">
              <a-input v-model="data.dutyName" placeholder="请输入负责人姓名">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="登录账号">
              <a-input v-model="data.dutyPhone" placeholder="请输入负责人电话">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="门店分类">
              <a-select
                v-model="data.categoryId"
                placeholder="请选择"
                style="width: 100%"
                @change="storeType"
              >
                <a-select-option
                  v-for="(item, index) in xiala"
                  :key="index"
                  :value="item.objId"
                >
                  {{ item.categoryName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="登录密码">
              <a-input v-model="data.password" placeholder="请输入登录密码">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="门店编号">
              <a-input v-model="data.shopNo" placeholder="请输入门店编号">
              </a-input>
            </a-form-model-item>
          </a-col>
<!--          <a-col :span="11" :offset="2" v-if="role === '0'">-->
          <a-col :span="11" :offset="2">
            <a-form-model-item label="商家">
              <a-select
                v-model="data.merchantsId"
                placeholder="请选择"
                style="width: 100%"
                @change="storeType"
              >
                <a-select-option
                  v-for="(item, index) in merchantsSelect"
                  :key="index"
                  :value="item.objId"
                >
                  {{ item.merchantsName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
<!--          <a-col :span="11" v-if="role === '0'">-->
          <a-col :span="11" >
            <a-form-model-item label="有效期">
              <a-date-picker style="width: 100%"  v-model:value="data.validDate" />
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="营业时间">
              <a-time-picker format="HH:mm:ss" @change="onChange1" /> -
              <a-time-picker format="HH:mm:ss" @change="onChange2" />
            </a-form-model-item>
          </a-col>
        </a-row>


        <a-row>
          <a-col :span="11">
            <a-form-model-item label="上传负责人证件">
              <a-row>
                <a-col :span="12">
                  <a-upload
                    :customRequest="uploadone"
                    list-type="picture-card"
                    :file-list="idcardFront"
                    @preview="handlePreview"
                    @change="IDCardFront"
                  >
                    <div v-if="idcardFront.length < 1">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">Upload</div>
                    </div>
                  </a-upload>
                  <a-modal
                    :visible="previewVisible"
                    :footer="null"
                    @cancel="handleCancel"
                  >
                    <img
                      alt="example"
                      style="width: 100%"
                      :src="IDCardFrontImage"
                    />
                  </a-modal>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-upload
              :customRequest="uploadtwo"
              list-type="picture-card"
              :file-list="idcardBack"
              @preview="handlePreview"
              @change="IDCardBcak"
            >
              <div v-if="idcardBack.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal
              :visible="previewVisible"
              :footer="null"
              @cancel="handleCancel"
            >
              <img alt="example" style="width: 100%" :src="IDCardBackImage" />
            </a-modal>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
      </a-form-model>
    </div>

    <!-- 营业执照信息 -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 营业执照信息 </a-col>
      </a-row>
      <!-- a-form-model ==>   layout="" -->
      <a-form-model
        :model="data"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="执照名称">
              <a-input v-model="data.licenseName" placeholder="请输入执照名称">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="执照注册号">
              <a-input
                v-model="data.licenseNo"
                placeholder="请输入社会统一代码"
              >
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="上传营业执照">
              <a-row>
                <!-- <a-col :span="12">
                  <a-upload
                    name="avatar"
                    list-type="picture-card"
                    class="avatar-uploader"
                    action="api/cityAdmin/mall/open/upload_file"
                    :before-upload="beforeUpload"
                    @change="handleChange"
                  >
                    <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
                    <div v-else>
                      <a-icon :type="loading ? 'loading' : 'plus'" />
                      <div class="ant-upload-text">Upload</div>
                    </div>
                  </a-upload>
                </a-col> -->
                <a-col :span="12">
                  <a-upload
                    :file-list="licenseImgList"
                    list-type="picture-card"
                    :customRequest="uploadthree"
                    @preview="handlePreview"
                    @change="handlList"
                  >
                    <div v-if="licenseImgList.length < 1">
                      <a-icon type="plus" />
                      <div class="ant-upload-text">Upload</div>
                    </div>
                  </a-upload>
                  <a-modal
                    :visible="previewVisible"
                    :footer="null"
                    @cancel="handleCancel"
                  >
                    <img alt="example" style="width: 100%" :src="imageUrl" />
                  </a-modal>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 地址信息 -->
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-row>
        <a-col :span="12"> 地址信息 </a-col>
      </a-row>
      <!-- a-form-model ==>   layout="" -->
      <a-form-model
        :model="formInline"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        labelAlign="left"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="归属地">
              <a-input v-model="details" placeholder="请输入门店名称">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2">
            <a-form-model-item label="详细地址">
              <a-input v-model="data.address" placeholder="请输入详细地址">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="地址搜索">
              <a-input id="tipInput" v-model="data.searchAddress" placeholder="请输入商户地址，或附近地标" @blur="searchAddress"></a-input>
<!--
              <a-input
                id="tipInput"
                v-model="data.address"
                placeholder="请输入商户地址，或附近地标"
                @keydown="searchAddress"
              >
 -->

              <!-- <span class="illustrate">1.参考地图定位，如果商家坐标不符，请纠正定位信息</span>
              <span class="illustrate">2.使用地址辅助搜索可快速定位商户所属地，点击地图获取商户精确坐标</span> -->
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>

        <a-row>
          <a-col :span="11">
            <a-form-model-item label="地图信息">
              <div class="amap-page-container">
                <div
                  id="mapChart"
                  :style="{ width: '70vh', height: '70vh' }"
                ></div>

                <div class="toolbar">
                  <span v-if="loaded">
                    location: lng = {{ lng }} lat = {{ lat }}
                  </span>
                  <span v-else>正在定位</span>
                </div>
                <div v-on:click="req_post()">查询周边</div>
              </div>

              <span class="illustrate"
                >1.参考地图定位，如果商家坐标不符，请纠正定位信息</span
              >
              <span class="illustrate"
                >2.使用地址辅助搜索可快速定位商户所属地，点击地图获取商户精确坐标</span
              >
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="2"> </a-col>
        </a-row>
      </a-form-model>
      <a-button @click="save">保存</a-button>
    </div>
  </div>
</template>

<script>
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
import { picUpload } from "@/api/storeApi.js";
import VueAMap from "vue-amap";
import { addStoreList, storeListEditXiala, merchantsListSelect } from "@/api/homeApi.js";
import { message } from "ant-design-vue";
// import AMapLoader from "@amap/amap-jsapi-loader";

// window._AMapSecurityConfig = {
//   securityJsCode:'eb9c059ce4eb6918dd99e400b1908984',
// }
export default {
  data() {
    return {
      previewVisible: false,
      IDCardFrontImage: "",
      IDCardBackImage: "",
      licenseImgList: [],
      idcardFront: [],
      idcardBack: [],
      xiala: "",
      merchantsSelect: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      formInline: {
        licenseName: "",
        password: "",
        adress: "",
      },
      imageUrl: "",
      loading: "",
      loaded: "",
      details: "",
      role: sessionStorage.getItem("role"),
      data: {
        hotelName: "", //门店名称
        dutyCardFront: "", //身份证正面
        dutyCardReverse: "", //身份证反面
        licenseName: "", //营业执照名称
        phone: "", //联系电话
        dutyName: "", //负责人姓名
        dutyPhone: "", //负责人电话
        address: "", //详细地址
        licenseImg: "", //营业执照
        longitude: "", // 经度
        latitude: "", // 纬度
        regionRecord: "{}",
        shopNo: "",
        merchantsId: "",// 商家id
        cityId: "3",
        areaId: "4",
        categoryId: "",
        // shopNo: "",
        password: "", //登录密码
        validDate: "", //登录密码
        searchAddress: "",
        endRunTime: "",
        startRunTime: "",
      },
      auto: null,
      map1: "",
      placeSearch: null,
      position: {}, //传给父组件的值【放经纬度和地址】
      lnglat: [], //   [longitude,latitude]
      marker: null
    };
  },
  created() {
    //应该是这个key没有加上，重新申请吗？需要？
  },
  mounted() {

    this.getStoreListEditXiala();
    this.getMerchantsListSelect();
    setTimeout(()=>{this.initmapFn();},1000)
  },
  methods: {
    handleSubmit(e) {
      console.log();
    },
    handleCancel() {
      this.previewVisible = false;
    },
    onChange1(time, startTime) {
      console.log(startTime, "startTime");
      this.data.startRunTime =startTime || "00:00:00";
    },
    onChange2(time, endTime) {
      console.log(endTime, "endTime");
      this.data.endRunTime = endTime || "23:59:59";
    },
    beforeUpload() {},
    storeType(e) {
      console.log("oooooooooooooooooop", e);
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handlList({ fileList }) {
      if (fileList == "") {
        this.licenseImgList = [];
      }
    },
    IDCardFront({ fileList }) {
      console.log("front----------", fileList);
      if (fileList == "") {
        this.idcardFront = [];
      }
    },
    IDCardBcak({ fileList }) {
      console.log("front----------", fileList);
      if (fileList == "") {
        this.idcardBack = [];
      }
    },
    initmapFn() {
      // this.$nextTick();
      this.map1 = new AMap.Map("mapChart", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 12, // 缩放级别
        center: [113.985868, 22.523237], //中心点坐标
      })
      let _this = this;
      this.auto = new AMap.Autocomplete({
        "input": "tipInput", // 使用联想输入的input的id
      });
      //构造地点查询类
      this.placeSearch = new AMap.PlaceSearch({
        map: _this.map1,
      });


      this.auto.on("select", function (e) {
        _this.searchMap(e);
      });
        // 监听鼠标点击事件
      this.map1.on("click", function (ev) {
          _this.getAddress([ev.lnglat.lng, ev.lnglat.lat]);
        });
      // }).catch(e=>{
      //   console.log('eeeeeeeeeeeeee',e)
      // });
    },
    // 关键字查询
    searchMap(e) {
      // 搜索框自动完成类
      let _this = this;
      AMap.plugin(["AMap.AutoComplete","AMap.PlaceSearch"], function () {
        // 当选中某条搜索记录时触发
          // _this.selectSite(ev)
          console.log("经纬度", e.poi.location.lng, e.poi.location.lat, e.poi.name);
          _this.lnglat = [e.poi.location.lng, e.poi.location.lat];
          _this.placeSearch.setCity(e.poi.adcode);
          _this.placeSearch.search(e.poi.name); //关键字查询
          _this.position = {
            longitude: e.poi.location.lng,
            latitude: e.poi.location.lat,
            address: e.poi.name,
          };

      })
    },
    //当选中某条搜索记录时触发
    selectSite(e) {
      console.log(e)
      console.log("经纬度", e.poi.location.lng, e.poi.location.lat, e.poi.name);
      this.lnglat = [e.poi.location.lng, e.poi.location.lat];
      this.placeSearch.setCity(e.poi.adcode);
      this.placeSearch.search(e.poi.name); //关键字查询
      this.position = {
        longitude: e.poi.location.lng,
        latitude: e.poi.location.lat,
        address: e.poi.name,
      };
      // this.$emit('selPosition',this.position)
    },
    // 经纬度转化为详细地址 注释了就没有地图了》刷新就不显是地图
    getAddress(e) {
      let that = this;
      AMap.plugin("AMap.Geocoder", function () {
        let geocoder = new AMap.Geocoder({
          radius: 100,
          extensions: "all",
        });

        geocoder.getAddress(e, function (status, result) {
          that.data.longitude = e[0];
          that.data.latitude = e[1];
          if (status === "complete" && result.info === "OK") {
            let address = result.regeocode.formattedAddress;
            console.log(result.regeocode);
            that.data.address = result.regeocode.formattedAddress;
            let a = result.regeocode.formattedAddress.slice(3, 9);
            that.details = a;
            // that.data.longitude=result.
            // that.placeSearch(that.address)
          }
        });
      });
    },
    //搜索地址
    searchAddress() {
      let that = this;
      if(that.marker!=null){
        that.map1.remove([that.marker]);
      }

      let placeSearch = new AMap.PlaceSearch({
        // city 指定搜索所在城市，支持传入格式有：城市名、citycode和adcode
        city: '全国', // 兴趣点城市
      });
      // 重点
      placeSearch.search(that.data.searchAddress, function(status, result) {
        console.log(result)
        // 查询成功时，result即对应匹配的POI信息
        var pois = [];
        pois = result.poiList.pois;
        that.marker = new AMap.Marker({
            position: pois[0].location, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
            title: pois[0].name,
          });
        that.getAddress([pois[0].location.lng, pois[0].location.lat]);
        that.map1.add(that.marker);
        that.map1.setFitView();
      });
    },
    // onMarkerMap(Q, R) {
    //   console.log("经度",Q)
    //   console.log("纬度",R)
    //   let marker = new AMap.Marker({
    //     //在回调函数里面创建Marker实例,添加经纬度和标题
    //     position: [Q, R], //添加经纬度
    //     offset: new AMap.Pixel(-13, -30), // 偏移量
    //     // title: "广州塔", // 鼠标移上去时显示的内容
    //     // 可以自定义标记点显示的内容,允许插入html字符串
    //     // content: "<h1>广州塔Content</h1>",
    //   });
    //   this.map1.add(marker); // 将创建的点标记添加到已有的地图实例： 这里吗
    //   this.map1.setFitView();
    // },
    cs() {
      console.log(this.data.storeName);
    },
    //身份证正面
    uploadone(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error(this.$file_max_size_text);
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.data.dutyCardFront = res.data;
          const originFileObj = {
            uid: "-1",
            name: "图片",
            status: "done",
            url: res.data,
            thumbUrl: res.data,
          };
          this.idcardFront.push(originFileObj);
          console.log("one", this.idcardFront);
          message.success("上传成功");
        })
        .catch((err) => {
          message.error(this.$file_max_size_text);
        });
    },
    //身份证反面
    uploadtwo(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error(this.$file_max_size_text);
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.data.dutyCardReverse = res.data;
          const originFileObj = {
            uid: "-1",
            name: "图片",
            status: "done",
            url: res.data,
            thumbUrl: res.data,
          };
          this.idcardBack.push(originFileObj);
          console.log("two", this.data.dutyCardReverse);
        })
        .catch((err) => {
          message.error(this.$file_max_size_text);
        });
    },
    //营业执照
    uploadthree(file) {
      // file是上传的文件
      const file_size = file.file.size;
      if (file_size > this.$file_max_size) {
        message.error(this.$file_max_size_text);
        return false;
      }
      const form = new FormData();
      form.append("file", file.file);
      form.append("contractName", file.file.name);
      form.append("description", file.file.name);
      picUpload(form)
        .then((res) => {
          this.data.licenseImg = res.data;
          const originFileObj = {
            uid: "-1",
            name: "图片",
            status: "done",
            url: res.data,
            thumbUrl: res.data,
          };
          this.licenseImgList.push(originFileObj);
          console.log("two", this.licenseImgList);
        })
        .catch((err) => {
          message.error(this.$file_max_size_text);
        });
    },
    save() {
      if (this.role === '27'){
        this.data.merchantsId = sessionStorage.getItem("objId");
      }
      console.log(this.data)
      this.data.password = this.$md5(this.data.password);
      addStoreList(this.data).then((res) => {
        console.log(res);
        message.success(res.info);
      });
      this.$router.push("/home/storeManagement/managementHom");
    },
    getStoreListEditXiala() {
      storeListEditXiala({ limit: 10, page: 1 }).then((res) => {
        this.xiala = res.data;
      });
    },
    getMerchantsListSelect() {
      merchantsListSelect().then(res =>{
        this.merchantsSelect = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped="" type="text/css">
.illustrate {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/storeManagement/storeManagement/newStore/newStore.vue